var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineUserSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25 7c0-3.17 2.58-5.75 5.75-5.75S17.75 3.83 17.75 7s-2.58 5.75-5.75 5.75S6.25 10.17 6.25 7zm1.5 0A4.26 4.26 0 0 0 12 11.25 4.26 4.26 0 0 0 16.25 7 4.26 4.26 0 0 0 12 2.75 4.26 4.26 0 0 0 7.75 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66 22c0-4.27 4.19-7.75 9.34-7.75.41 0 .75.34.75.75s-.34.75-.75.75c-4.32 0-7.84 2.8-7.84 6.25 0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 18.2c0-2.18 1.77-3.95 3.95-3.95s3.95 1.77 3.95 3.95-1.77 3.95-3.95 3.95-3.95-1.77-3.95-3.95zm1.5 0c0 1.35 1.1 2.45 2.45 2.45s2.45-1.1 2.45-2.45-1.1-2.45-2.45-2.45-2.45 1.1-2.45 2.45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.47 22.53-1-1a.755.755 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l1 1c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22s-.38-.07-.53-.22z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineUserSearch);
export default __webpack_public_path__ + "static/media/vuesax-outline-user-search.be1bfd7926ed2739c1ef5ef8e39544f8.svg";
export { ForwardRef as ReactComponent };